import { invertObject } from 'common'

export const LISTING_TYPE_ONLINE = 0b01
export const LISTING_TYPE_PHYSICAL = 0b10
export const LISTING_TYPE_ALL = LISTING_TYPE_ONLINE | LISTING_TYPE_PHYSICAL

export const PROMO_TYPE_LISTING = 0b01
export const PROMO_TYPE_PACK = 0b10
export const PROMO_TYPE_ALL = PROMO_TYPE_LISTING | PROMO_TYPE_PACK

export const LISTING_TYPE_FLAG_TO_STR = {
  [LISTING_TYPE_ALL]: 'all',
  [LISTING_TYPE_PHYSICAL]: 'physical',
  [LISTING_TYPE_ONLINE]: 'online'
}
export const LISTING_TYPE_STR_TO_FLAG = invertObject(LISTING_TYPE_FLAG_TO_STR)

export const PROMO_TYPE_FLAG_TO_STR = {
  [PROMO_TYPE_LISTING]: 'promo_type_listing',
  [PROMO_TYPE_PACK]: 'promo_type_pack',
  [PROMO_TYPE_ALL]: 'promo_type_all'
}
export const PROMO_TYPE_STR_TO_FLAG = invertObject(PROMO_TYPE_FLAG_TO_STR)
